import {
  fieldEntryHasPresentableValue,
  fieldEntryLooksEmptyIncoming,
} from '@/common/utils/changedDataFieldMerge'

function readNamedEntry(data: unknown, fieldName: string): unknown {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return undefined
  return (data as Record<string, unknown>)[fieldName]
}

function isPresentableTextEntry(entry: unknown): boolean {
  if (entry === undefined || entry === null) return false
  if (fieldEntryLooksEmptyIncoming(entry)) return false
  return fieldEntryHasPresentableValue(entry) || typeof entry === 'string' || typeof entry === 'number'
}

/**
 * SwingText.getData after fill: presentable hook, else forms slot, else page field.
 * Does not call form-level getForm.
 */
export function pickPresentableTextGetData(
  fieldName: string,
  hookData: unknown,
  slotEntry: unknown,
  pageEntry?: unknown,
): Record<string, unknown> {
  const name = String(fieldName ?? '').trim()
  if (!name) return {}
  const fromHook = readNamedEntry(hookData, name)
  if (isPresentableTextEntry(fromHook)) {
    return { [name]: fromHook }
  }
  if (isPresentableTextEntry(slotEntry)) {
    return { [name]: slotEntry }
  }
  if (isPresentableTextEntry(pageEntry)) {
    return { [name]: pageEntry }
  }
  return {}
}

export function readFormsElementSlotField(
  forms: Record<string, unknown> | null | undefined,
  storageFormId: string,
  panelBucket: string,
  elementId: string | number,
  fieldName: string,
): unknown {
  const fid = String(storageFormId ?? '').trim()
  const bucket = String(panelBucket ?? '').trim()
  const eid = String(elementId ?? '').trim()
  const name = String(fieldName ?? '').trim()
  if (!fid || !bucket || !eid || !name || !forms) return undefined
  const formBucket = forms[fid]
  if (!formBucket || typeof formBucket !== 'object' || Array.isArray(formBucket)) return undefined
  const panel = (formBucket as Record<string, unknown>)[bucket]
  if (!panel || typeof panel !== 'object' || Array.isArray(panel)) return undefined
  const slot = (panel as Record<string, unknown>)[eid]
  if (!slot || typeof slot !== 'object' || Array.isArray(slot)) return undefined
  return (slot as Record<string, unknown>)[name]
}
